// http://10.232.48.119:9000/
// http://192.168.0.107:9000/
// http://127.0.0.1:9000/
// 接口地址
// export const baseURL = process.env.VUE_APP_REQUEST_URL;

export const baseURL = "https://6gamehub.com/static/";
